import React from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@material-ui/core/Box';
import { Link } from '@material-ui/core';
import { CustomLink } from 'components/Links';
import { Typography } from '@material-ui/core';
import { NotInterested } from '@material-ui/icons';

interface Props {
  pageTitle?: string;
}

export const UserNotPermittedComponent = ({ pageTitle }: Props): JSX.Element => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100%" flexDirection="column" data-testid="user-not-permitted">
      <Helmet><title>Nwave Console { pageTitle ? `| ${pageTitle}` : '' }</title></Helmet>
      <NotInterested fontSize="large" color="error" />
      <Typography variant="h6">
        You don't have permissions to see this page
      </Typography>

      <Box mt={ 1 }>
        <Link color="secondary" component={ CustomLink } to={ '/' }>Return to Home</Link>
      </Box>
    </Box>
  );
};
